export default "__VITE_ASSET__9dd1fcf7__"